import type { IStateIcon } from "../../types/state_icon";
import { Circle } from "@unified-checkout/design-system/icons/index";
import styles from "./state-icon.module.scss";

export const StateIcon = ({
  status = 'default',
  icon
}: IStateIcon) => {
  return (
    <div
      className={styles["state-icon"]}
      data-indicator-status={status}>
      {icon || Circle}
    </div>
  )
}
